module.exports = __webpack_public_path__ + "img/AGlogo.dad55128.svg";